module.exports = __webpack_public_path__ + "14714e95842d66baa0e40f1ca13755f8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/jumbotron_logo.png
// module id = 1238
// module chunks = 0